import "./rmaMerchantSelfOnboardingProduction.js";
import "./rmaMerchantSelfOnboardingSandbox.js";
import "./rmaMerchantAccountConfigurationSandbox.js";
import "./rmaMerchantAccountConfigurationProduction.js";
import "./rmaSelfRegistarionForm.js";
import "./rmaSandboxSelfRegistarionForm.js";




// WEBPACK FOOTER //
// ./src/pages/rmaMerchantSelfOnboarding/index.js